/**
 * @fileoverview 管理页面的搜索、增加、删除、编辑操作
 */

import { MessageBox, Message  } from 'element-ui'

import router from '@/router/index'
// import global from './global'

/**
 * 执行搜索操作的异步函数
 * @param {Function} func - 用于执行搜索请求的异步函数，接收 pageData 作为参数
 * @param {Object} searchData - 搜索所需的数据对象
 * @param {Object} pageData - 分页相关的数据对象，会将 searchData 合并到该对象中
 * @returns {Promise<Object|undefined>} - 如果搜索成功，返回包含搜索结果数据的 Promise；否则返回 undefined
 */
export async function searchHandler (func, searchData, pageData) {
  Object.assign(pageData, searchData)
  const res = await func(pageData)
  return res
}

/**
 * 执行删除操作的异步函数
 * @param {Function} func - 用于执行删除请求的异步函数，接收一个包含 ids 属性的对象作为参数
 * @param {Array} ids - 要删除的项目的 ID 列表
 * @param {string} hint - 用于在提示信息中描述要删除的项目类型，如“用户”、“订单”等
 * @param {Boolean} isSingel - 用于判断是批量删除还是表格行内单个删除(可选)
 * @returns {Promise<boolean>} - 返回一个 Promise，解析为一个布尔值，表示删除操作是否成功
 */
export async function deleteHandler (func, ids, hint, isSingel = true) {
  // 检查当前选中的 ID 列表是否为空，如果为空则提示用户选择要删除的项目
  if (ids.length === 0 && isSingel) {
    Message.warning(`请选择要删除的${hint}`)
    return false
  }

  // 弹出确认框，让用户确认是否要删除项目
  const res = MessageBox.confirm(`是否删除该${hint}?`, '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    this.loading = true
    // 如果用户确认删除，则执行删除操作
    const res = await func(ids)
    if (res.code === 200) {
      Message.success(res.msg)
      return true
    } else {
      return false
    }
  }).catch(() => { return false })
  return res
}

/**
 * 执行添加操作的异步函数，用于导航到指定页面并添加页面标签
 * @param {string} path - 要导航到的页面路径
 * @param {string} title - 要添加的页面标签的标题
 */
export async function addHandler (path, title, type) {
  router.push({
    path: path,
    query: {
      type: type
    }
  })
  // global.add_pageTabs(
  //   {
  //     title: title,
  //     key: path
  //   }
  // )
}

export async function editHandler (path, title, viewName, type, id, mappingtype) {
  router.push({
    path: path,
    query: {
      type: type,
      id: id,
      mappingType: mappingtype
    }
  })
  // global.add_pageTabs(
  //   {
  //     title: title,
  //     key: path,
  //     name: viewName
  //   }
  // )
}

/**
 * 将给定的日期字符串格式化为 'YYYY-MM-DD' 格式
 *
 * @param {string} dateStr - 日期字符串，格式为 'YYYY-MM-DD'
 * @returns {string} 格式化后的日期字符串，格式为 'YYYY-MM-DD'
 */
export function formatLocalDate (dateStr) {
  const date = new Date(dateStr)
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * 根据字典类型过滤数据
 * @param {Array} data - 原始数据数组
 * @param {string} dictCode - 要过滤的字典类型
 * @returns {Array} 过滤后的数据数组
 */
export function filterByDictCode (data, dictCode) {
  if (!Array.isArray(data)) {
    console.error('第一个参数必须是数组')
    return []
  }

  return data.filter(item => item.dictCode === dictCode)
}

/**
 * 根据字典代码将选项分配给搜索列表中的项目
 *
 * @param {Array} searchList - 要处理的搜索列表
 * @param {Object} propDictMap - 属性与字典代码之间的映射关系
 * @param {Object} dictionary - 字典对象
 */
export function assignDictOptions (searchList, propDictMap, dictionary) {
  const cache = new Map()

  Object.entries(propDictMap).forEach(([prop, dictCode]) => {
    if (!cache.has(dictCode)) {
      cache.set(dictCode, this.$filterByDictCode(dictionary, dictCode))
    }

    searchList
      .filter(item => item.prop === prop)
      .forEach(item => {
        item.options = cache.get(dictCode)
      })
  })
  // console.log('字典', cache)
}
/**
 * 从给定的字典数组中筛选出类型为'serial_type'的项
 *
 * @param selectDictionary 字典数组，数组中的每个元素都是一个对象，每个对象包含一个dictCode属性
 * @returns 返回一个包含所有类型为'serial_type'的项的数组
 * 专用于产品测试-端口配置界面的字典值
 */
export function filterSerialType (selectDictionary) {
  const serialTypeList = []

  // 遍历整个字典数组
  selectDictionary.forEach(item => {
    // 检查当前项的dictCode是否为'serial_type'
    if (item.dictCode === 'serial_type') {
      // 将符合条件的项添加到结果数组
      serialTypeList.push(item)
    }
  })

  return serialTypeList
}
